import { chain, trimEnd } from 'lodash';
import { urijs } from '../helpers/urijs';
import { readableUrl } from './uri';
export const getRawOuterUrl = (path, sectionUrl) => {
    const url = new urijs(sectionUrl || '').unicode();
    if (path === '' && url.hostname() && sectionUrl?.endsWith(url.hostname())) {
        return sectionUrl;
    }
    const location = new urijs(path).unicode();
    const pathname = trimEnd(readableUrl(url.pathname()), '/') + location.pathname();
    // addQuery breaks for encoded characters
    const query = chain([url.query(), location.query()]).compact().join('&').value();
    url.pathname(pathname);
    url.query(query);
    url.hash(location.hash() || url.hash());
    return url.toString();
};
export const getOuterUrl = (path, sectionUrl) => readableUrl(getRawOuterUrl(path, sectionUrl));
//# sourceMappingURL=get-outer-url.js.map